import { motion } from "framer-motion";
import { MapPin, CalendarClock, CreditCard, Smile } from "lucide-react";

const STEPS = [
  {
    icon: MapPin,
    title: "Indiquez vos adresses",
    text: "Point de départ (drive, magasin, relais) et adresse de livraison. Rien de plus.",
  },
  {
    icon: CalendarClock,
    title: "Choisissez votre créneau",
    text: "Matin ou après-midi, du lundi au samedi. Je confirme chaque rendez-vous par téléphone.",
  },
  {
    icon: CreditCard,
    title: "Payez comme vous voulez",
    text: "Carte bancaire en ligne, espèces à la livraison ou virement. Le prix est indiqué avant, puis confirmé avec vous.",
  },
  {
    icon: Smile,
    title: "Livré avec le sourire",
    text: "Je livre en main propre, je monte les sacs, et je prends le temps d'échanger si besoin.",
  },
];

export default function HowItWorks() {
  return (
    <section id="fonctionnement" className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 max-w-2xl"
        >
          <span className="mb-4 inline-flex w-fit rounded-full bg-forest/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-forest">
            Comment ça marche
          </span>
          <h2 className="font-serif text-2xl font-semibold tracking-tight text-ink sm:text-3xl lg:text-4xl">
            Simple comme un coup de fil à <em className="italic text-terra">un voisin</em>
          </h2>
        </motion.div>

        <ol className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {STEPS.map((step, i) => (
            <motion.li
              key={step.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
              data-testid={`step-${i + 1}`}
            >
              <span className="font-serif text-6xl font-semibold text-sand" aria-hidden="true">
                0{i + 1}
              </span>
              <span className="mt-[-1.6rem] mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-terra text-white shadow-lg shadow-terra/30">
                <step.icon className="h-6 w-6" />
              </span>
              <h3 className="mb-2 text-lg font-semibold text-ink sm:text-xl">{step.title}</h3>
              <p className="text-base leading-relaxed text-ink/65">{step.text}</p>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
